import React, { useState } from 'react';
import TwoFactorAuthForm from './TwoFactorAuthForm';
import logo from '../../../assets/logo/LOGO_CAPBAY_VERTICAL_CROPPED.png';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { useDict } from '../../../contexts/LanguageContext';

const TwoFactorAuth = () => {
    const dict = useDict();

    const [isLoading, setIsLoading] = useState(false);

    return (
        <>
            {isLoading && <LoadingSpinner />}
            <div className="account account--photo">
                <div className="account__wrapper">
                    <div className="account__card">
                        <span
                            className="account__logo"
                            style={{
                                width: '200px',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                display: 'block',
                            }}
                        >
                            <img src={logo} alt="logo" style={{ width: '200px' }} />
                        </span>
                        <TwoFactorAuthForm />
                        <div className="account__or_divide">
                            <div className="regulated-by-text">
                                {dict.regulatedByText}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default TwoFactorAuth;
